// P1-030: Settings panel — neon industrial design
import { useState } from 'react';
import { useSettingsStore } from '@/shared/stores/settingsStore';

export function SettingsPanel() {
  const bgmVolume = useSettingsStore((s) => s.bgmVolume);
  const sfxVolume = useSettingsStore((s) => s.sfxVolume);
  const language = useSettingsStore((s) => s.language);
  const setBgmVolume = useSettingsStore((s) => s.setBgmVolume);
  const setSfxVolume = useSettingsStore((s) => s.setSfxVolume);
  const setLanguage = useSettingsStore((s) => s.setLanguage);

  const [showResetConfirm, setShowResetConfirm] = useState(false);

  const handleReset = () => {
    if (!showResetConfirm) {
      setShowResetConfirm(true);
      return;
    }
    localStorage.clear();
    window.location.reload();
  };

  return (
    <div className="settings-panel">
      <h2 className="settings-panel__title">设置 SETTINGS</h2>

      <div className="settings-panel__list">
        {/* Volume */}
        <div className="settings-panel__row">
          <span className="settings-panel__label">VOLUME</span>
          <div className="settings-panel__control">
            <input
              className="settings-panel__slider"
              type="range"
              min={0}
              max={1}
              step={0.01}
              value={sfxVolume}
              style={{ '--pct': `${sfxVolume * 100}%` } as React.CSSProperties}
              onChange={(e) => setSfxVolume(Number(e.target.value))}
            />
            <span className="settings-panel__value">{Math.round(sfxVolume * 100)}%</span>
          </div>
        </div>

        {/* Music */}
        <div className="settings-panel__row">
          <span className="settings-panel__label">MUSIC</span>
          <div className="settings-panel__control">
            <input
              className="settings-panel__slider"
              type="range"
              min={0}
              max={1}
              step={0.01}
              value={bgmVolume}
              style={{ '--pct': `${bgmVolume * 100}%` } as React.CSSProperties}
              onChange={(e) => setBgmVolume(Number(e.target.value))}
            />
            <span className="settings-panel__value">{Math.round(bgmVolume * 100)}%</span>
          </div>
        </div>

        {/* Language */}
        <div className="settings-panel__row">
          <span className="settings-panel__label">LANGUAGE</span>
          <div className="settings-panel__control">
            <button
              className={`settings-panel__lang-btn ${language === 'zh' ? 'settings-panel__lang-btn--active' : ''}`}
              onClick={() => setLanguage('zh')}
            >中文</button>
            <button
              className={`settings-panel__lang-btn ${language === 'en' ? 'settings-panel__lang-btn--active' : ''}`}
              onClick={() => setLanguage('en')}
            >ENGLISH</button>
          </div>
        </div>

        {/* Account */}
        <div className="settings-panel__row">
          <span className="settings-panel__label">ACCOUNT</span>
          <div className="settings-panel__control">
            <span className="settings-panel__value">player_001</span>
          </div>
        </div>

        {/* Save Data */}
        <div className="settings-panel__row">
          <span className="settings-panel__label">SAVE DATA</span>
          <div className="settings-panel__control">
            <span className="settings-panel__value">LOCAL STORAGE</span>
          </div>
        </div>

        {/* Reset */}
        <div className="settings-panel__row settings-panel__row--danger">
          <span className="settings-panel__label settings-panel__label--danger">RESET DATA</span>
          <div className="settings-panel__control">
            {showResetConfirm ? (
              <>
                <button className="settings-panel__reset-btn" onClick={handleReset}>CONFIRM</button>
                <button className="settings-panel__cancel-btn" onClick={() => setShowResetConfirm(false)}>CANCEL</button>
              </>
            ) : (
              <span className="settings-panel__danger-tag" onClick={handleReset}>⚠ DANGER</span>
            )}
          </div>
        </div>
      </div>

      <div className="settings-panel__footer">
        VERSION 0.1.0-MVP // 硅谷:人工XX
      </div>
    </div>
  );
}
